
    import './styles.scoped.css';
    export default {
  "wrapper": "awsui_wrapper_z5mul_od2g2_93",
  "wrapper--fit-height": "awsui_wrapper--fit-height_z5mul_od2g2_129",
  "inner-wrapper--fit-height": "awsui_inner-wrapper--fit-height_z5mul_od2g2_134",
  "has-default-filter": "awsui_has-default-filter_z5mul_od2g2_140",
  "content": "awsui_content_z5mul_od2g2_144",
  "content--reserve-filter": "awsui_content--reserve-filter_z5mul_od2g2_151",
  "content--reserve-legend": "awsui_content--reserve-legend_z5mul_od2g2_155",
  "content--fit-height": "awsui_content--fit-height_z5mul_od2g2_159",
  "filter-container": "awsui_filter-container_z5mul_od2g2_163"
};
  